﻿(function () {
    'use strict';
    var $stateProviderRef = null;

    angular.module('app.config').config(['$stateProvider', '$urlRouterProvider', routeConfigurator]);

    function routeConfigurator($stateProvider, $urlRouterProvider) {
        var dataRoutes = [
            {
                name: 'login',
                state: {
                    url: '/login',
                    templateUrl: 'app/components/shared/login/loginUser.html',
                    access: { loginRequired: false, isRoot: true }
                }
            },
            {
                name: 'changepassword',
                state: {
                    url: '/changepassword',
                    templateUrl: 'app/components/shared/login/loginUser.html',
                    access: { loginRequired: true, isRoot: true }
                }
            },
            {
                name: 'createaccount',
                state: {
                    url: '/createaccount',
                    templateUrl: 'app/components/shared/login/createaccount.html',
                    access: { loginRequired: false}
                }
            },
            {
                name: 'root',
                state: {
                    url: '/',
                    views: {
                        '@': { templateUrl: 'app/components/shared/layout.html' },
                        'header@root': { templateUrl: 'app/components/shared/header.html', },
                        'footer@root': { templateUrl: 'app/components/shared/footer.html', },
                        'main@root': { templateUrl: 'app/components/Dashboard/dashboard.html' }
                    },
                    access: { loginRequired: true }
                }
            },
            {
                name: 'eirReport',
                state: {
                  url: '/Eir/Report/:EIRId/:EIRNo/:LanguageId/:UrlLogoOrganization',
                  views: {
                    '@': { templateUrl: 'app/components/shared/layoutreport.html' },
                    'main@eirReport': { templateUrl: 'app/components/report/eirPrint.html' }
                  },
                  access: { loginRequired: true }
                }
              }
        ];

        angular.forEach(dataRoutes, function (data) {
            setRoute(data.name, data.state);
        });

        function setRoute(name, definition) {
            definition.resolve = angular.extend(definition.resolve || {}, {
                prime: prime
            });
            $stateProvider.state(name, definition);
        }

        $urlRouterProvider.deferIntercept();
        $urlRouterProvider.otherwise('/');

        $stateProviderRef = $stateProvider;
    }

    angular.module('app').run([
        'datacontext',
        '$rootScope',
        '$urlRouter',
        'localStorageService',
        'common',
        function (datacontext, $rootScope, $urlRouter, localStorageService, common) {
            $stateProviderRef
                .state('root.appmntCtainerEntryEdit', {
                    url: 'AppointmentContainerEntry/Edit',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/appointmentcontainerentry/appmntCtainerEntryEdit.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.appmntCtainerEntrySearch', {
                    url: 'AppointmentContainerEntry/Search',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/appointmentcontainerentry/appmntCtainerEntrySearch.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.appointment', {
                    url: 'Appointment/Search',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/appointment/appointmentSearch.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.appointmentReport', {
                    url: 'Appointment/Report/:idap/:userTimeZone',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/appointmentInPrint.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.appointmentQR', {
                    url: 'Appointment/QR/:idap',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/appointment/appointmentInQR.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.appointmentMainApptSchedule', {
                    url: 'Appointment/MainSchedule/:type',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/appointment/appointmentMainApptSchedule.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.appointmentMainApptSchedule2', {
                    url: 'Appointment/MainSchedule/:type',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/appointment/appointmentMainApptSchedule.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.appointmentCreate2', {
                    //url: 'Appointment/Create2/:idc/:f/:h',
                    url: 'Appointment/Create2',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/appointment/appointmentCreate2.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.equipmentTracking', {
                    url: 'EquipmentTracking/Search',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/equipmenttracking/equipmentTrackingSearch.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.truckTracking', {
                    url: 'TruckTracking/Search',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/trucktracking/truckTrackingSearch.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.equipmentDamage', {
                    url: 'EquipmentDamage/Search',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/equipmentdamage/equipmentDamageSearch.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.eir', {
                    url: 'Eir/Search',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/eir/eirSearch.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.progressDepotOrder', {
                    url: 'ReportList/ProgressDepotOrder',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/progressDepotOrderDetail.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.equipmentStock', {
                    url: 'ReportList/EquipmentStock',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/equipmentStock.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.containerReception', {
                    url: 'ReportList/ContainerReception',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/containerReception.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.inspectionTime', {
                    url: 'ReportList/InspectionTime',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/inspectionTime.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.stockSummary', {
                    url: 'ReportList/StockSummary',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/stockSummary.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.repairTime', {
                    url: 'ReportList/RepairTime',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/repairTime.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.longStanding', {
                    url: 'ReportList/LongStanding',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/longStanding.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.gateOperationInventory', {
                    url: 'ReportList/GateOperationInventory',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/gateOperationInventory.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.OOS', {
                    url: 'ReportList/oos',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/oos.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.DryReefer', {
                    url: 'ReportList/dryreefer',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/dryreefer.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.serviceTime', {
                    url: 'ReportList/ServiceTime',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/serviceTime.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.serviceTimeShipper', {
                    url: 'ReportList/ServiceTimeShipper',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/report/serviceTimeShipper.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                .state('root.eirGTOPrint', {
                    url: 'EIR/GTOTicket/:EIRId',
                    views: {
                        'main@root': {
                            templateUrl: 'app/components/eir/eirGTOPrint.html'
                        }
                    },
                    access: { loginRequired: true }
                })
                ;


            /*.state('root.appointmentS', {
                url: 'Appointment/Create',
                views: {
                    'main@root': {
                        templateUrl: 'app/components/appointment/appointmentCreate.html'
                    }
                },
                access: { loginRequired: true }
            })*/

            $urlRouter.sync();
            $urlRouter.listen();

            //validate session an clear localstorage
            var sessionActive = common.readCookie("sessionTDP");
            if (sessionActive != 1) {
                var latitude = common.localStorageService.get('latitude');
                var longitude = common.localStorageService.get('longitude');
                common.localStorageService.clearAll();
                common.localStorageService.set('latitude', latitude);
                common.localStorageService.set('longitude', longitude); 
            }

            var authData = localStorageService.get('authorizationData');
            if (authData) {

                //datacontext.security.getTest().then(function (data) {
                //    localStorageService.remove('menuBarData');
                //    //contruir las rutas en base a la configuracion del menu de la base de datos
                //    //$stateProviderRef
                //    //    .state('root.appmntCtainerEntryEdit', {
                //    //        url: 'AppointmentContainerEntry/Edit',
                //    //        views: {
                //    //            'main@root': {
                //    //                templateUrl: 'app/components/appointmentcontainerentry/appmntCtainerEntryEdit.html'
                //    //            }
                //    //        },
                //    //        access: { loginRequired: true }
                //    //    })
                //    //    .state('root.appmntCtainerEntrySearch', {
                //    //        url: 'AppointmentContainerEntry/Search',
                //    //        views: {
                //    //            'main@root': {
                //    //                templateUrl: 'app/components/appointmentcontainerentry/appmntCtainerEntrySearch.html'
                //    //            }
                //    //        },
                //    //        access: { loginRequired: true }
                //    //    });
                //    //$urlRouter.sync();
                //    //$urlRouter.listen();
                //    localStorageService.set('menuBarData', data);
                //    $rootScope.$broadcast('event:menu-load');
                //    });
            } else {
                $urlRouter.sync();
                $urlRouter.listen();
            }

        }]);

    prime.$inject = ['datacontext'];
    function prime(dc) { return dc.prime(); }

    /*
    --En una sola pantalla Create/Edit
    .state('root.appointmentEdit', {
                        url: 'Appointment/Edit/:idap',
                        views: {
                            'main@root': {
                                templateUrl: 'app/components/appointment/appointmentEdit.html'
                            }
                        },
                        access: { loginRequired: true }
                    })
    */

})();
